'use client';
import { createContext } from 'react';

import { type Visit } from '../types';

export type VisitContext = {
  visit?: Visit;
  setVisit: (visit: Visit) => void;
};

export const VisitContext = createContext<VisitContext | undefined>(undefined);
